import React from 'react'

const IconRemote = ({ width = '24', height = '24' }) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={`${width}px`}
    height={`${height}px`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Remote-Icon">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M22.0001 6.5C22.0001 6.58351 21.9985 6.66666 21.9954 6.74941L20.4997 6.56245C20.4999 6.54167 20.5001 6.52085 20.5001 6.5C20.5001 3.73858 18.2615 1.5 15.5001 1.5C15.4166 1.5 15.3336 1.50205 15.2511 1.50609L15.0032 0.0187084C15.1672 0.00631121 15.3329 0 15.5001 0C19.0899 0 22.0001 2.91015 22.0001 6.5ZM19 6C19 6.12601 18.9922 6.25021 18.9771 6.37214L17.4886 6.18607C17.4961 6.12511 17.5 6.06301 17.5 6C17.5 5.17157 16.8284 4.5 16 4.5C15.916 4.5 15.8336 4.50691 15.7534 4.52018L15.5067 3.04036C15.6672 3.01381 15.832 3 16 3C17.6568 3 19 4.34315 19 6ZM14 5H3V24H17V8C17 6.34315 15.6569 5 14 5ZM5 22V20H9V22H5ZM11 20V22H15V20H11ZM9 18H11H15V10H5V18H9ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H12.5C12.7761 8 13 7.77614 13 7.5C13 7.22386 12.7761 7 12.5 7H7.5Z"
      />
    </g>
  </svg>
)

export default IconRemote
